import getDistanceFromLatLonInKm from "./getDistanceFromLatLonInKm"

const zoomMapToCenters = function (placeSelected, centerInformation, radiusInKm) {
  const searchRadius = radiusInKm ?? 5
  const hasSelectedPlace = !!placeSelected
  const hasGeometry = hasSelectedPlace && placeSelected.geometry

  if (hasGeometry) {
    return centerInformation
      .map((center) => ({ center, distance: getDistanceFromLatLonInKm(placeSelected, center) }))
      .filter(({ distance }) => distance <= searchRadius)
      .sort((a, b) => a.distance - b.distance)
      .map(({ center }) => center)
  }

  return centerInformation
}

export default zoomMapToCenters
